import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Chip, Paper, Stack, Typography } from '@mui/material';
import { useMockPortal } from './mock/useMockPortal';
import { formatPortalDate } from './mock/store';

const statusLabel: Record<string, string> = {
  not_started: 'Not started',
  in_progress: 'In progress',
  pending: 'Pending review',
};

const ApplicationsPortal: React.FC = () => {
  const { application } = useMockPortal();

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Applications
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        View the status of your P.E.O. educational loan application.
      </Typography>

      <Paper variant="outlined" sx={{ p: 3 }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Typography variant="h6">
            Educational Loan Fund application
          </Typography>
          <Chip
            label={statusLabel[application.status] || application.status}
            color={application.status === 'pending' ? 'warning' : 'default'}
            size="small"
          />
        </Stack>

        {application.referenceId && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Reference: {application.referenceId}
          </Typography>
        )}
        {application.lastUpdated && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Last updated: {formatPortalDate(application.lastUpdated)}
          </Typography>
        )}

        {application.status === 'pending' && (
          <Typography sx={{ mb: 2 }}>
            Your application has been submitted and is awaiting review. You will
            be contacted if additional information is needed.
          </Typography>
        )}

        {application.status === 'not_started' && (
          <Typography sx={{ mb: 2 }}>
            You have not started an application yet.
          </Typography>
        )}

        <Button
          component={RouterLink}
          to="/portal/applications/start"
          variant={
            application.status === 'not_started' ? 'contained' : 'outlined'
          }
        >
          {application.status === 'not_started'
            ? 'Start application'
            : 'View start information'}
        </Button>
      </Paper>
    </Box>
  );
};

export default ApplicationsPortal;
